// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Merriweather', 'Merriweather Fallback'"},"className":"__className_1718fa"};